import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import React, { ReactElement } from "react";
import styled from "styled-components";
import Sidebar from "../components/Sidebar";
import TopAppBar from "./TopAppBar";

const StyledContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  position: "relative",
  backgroundColor: theme.palette.background.default,
}));

const StyledContentContainer = styled(Box)<{ maxWidth: string | number }>(
  ({ theme, maxWidth }) => ({
    width: "100%",
    maxWidth,
    margin: "0 auto",
    backgroundColor: theme.palette.background.default,
    paddingTop: theme.spacing(2),
    paddingRight: "80px",
    paddingLeft: "80px",
  })
);

const MainLayout: React.FC<{ children: ReactElement; width?: number }> = ({
  children,
  width = 1200,
}) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  let maxWidth: string | number = width;
  if (isMobile) {
    maxWidth = "800px"; // Adjust for mobile
  } else if (isTablet) {
    maxWidth = 800; // Adjust for tablets
  } else if (isDesktop) {
    maxWidth = 1200; // Default for desktops
  }

  return (
    <Stack
      direction={"row"}
    >
      <Sidebar />

      <StyledContainer>
        <TopAppBar />
        <StyledContentContainer maxWidth={maxWidth}>
          {children}
        </StyledContentContainer>
      </StyledContainer>
    </Stack>
  );
};

export default MainLayout;
